module.exports = __webpack_public_path__ + "img/20191014165454480.149da4d4.jpg";